import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCSq-8F5gl8AHbpDseGuYcMkrix1pPGemk",
  authDomain: "plhouse-96439.firebaseapp.com",
  projectId: "plhouse-96439",
  storageBucket: "plhouse-96439.firebasestorage.app",
  messagingSenderId: "144007918797",
  appId: "1:144007918797:web:4b55efd6beb8335e9b6584",
  measurementId: "G-DNDK5BDPE0"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// FCM messaging — 브라우저 지원 시에만 인스턴스 생성 (Safari 일부, 비보안 컨텍스트 등 제외)
export const getMessagingIfSupported = async () => {
  try {
    const ok = await isSupported();
    return ok ? getMessaging(app) : null;
  } catch {
    return null;
  }
};

export default app;
